const angular = require('angular');
const app = angular.module('learn-services');

/**
 * Service for adding and updating multiple users at a time
 * @argument {Application} Application defines the Application service
 * @argument {$q} $q defines the $q service
 * @argument {Categories} Categories defines the Categories resource
 */
app.factory('ContentAuth', ['Application', 'Authorization', 'Categories', 'explorer', 'Users', '$q', function (Application, Authorization, Categories, explorer, Users, $q) {
  var user = Authorization.getAuthToken().user;

  var privacyValues = ['privacy_departments', 'privacy_locations', 'privacy_teams', 'privacy_org_levels', 'privacy_grades', 'privacy_groups'];
  var MSWToPrivacy = {
    department: 'privacy_departments',
    location: 'privacy_locations',
    team: 'privacy_teams',
    org_level: 'privacy_org_levels',
    grade: 'privacy_grades',
    group: 'privacy_groups'
  };
  var allToPrivacy = {
    all_departments: 'privacy_departments',
    all_locations: 'privacy_locations',
    all_teams: 'privacy_teams',
    all_org_levels: 'privacy_org_levels',
    all_grades: 'privacy_grades',
    all_groups: 'privacy_groups'
  };

  var allowView = function(content, asSegmentation) {
    var deferred = $q.defer();

    if (asSegmentation) {
      if (!content || !content.segmentation) {
        deferred.resolve(false);
        return deferred.promise;
      }

      const translatedContent = {
        private: !!content.private
      };

      privacyValues.forEach(item => {
        translatedContent[item] = [];
      });

      content.segmentation.forEach(item => {
        if (item.type && item.id && MSWToPrivacy[item.type] && translatedContent[MSWToPrivacy[item.type]]) {
          translatedContent[MSWToPrivacy[item.type]].push(item.id);
        }
      });

      content = translatedContent;

    }

    var privacyBlock = {};
    privacyValues.forEach(function(value) {
      privacyBlock[value] = {user_values: [], passed: false};
    });

    if (!content) {
      deferred.resolve(true);
      return deferred.promise;
    }

    if (user.role === 'external') {
      // Deny for external users
      var external_department = Authorization.getAuthToken().company && Authorization.getAuthToken().company.external_department;
      if (!external_department || !content.privacy_departments || !content.privacy_departments.length) {
        deferred.resolve(false);
        return deferred.promise;
      }
      if (content.privacy_departments.indexOf(external_department) === -1) {
        deferred.resolve(false);
        return deferred.promise;
      }
    }

    if (!content.private) {
      deferred.resolve(true);
      return deferred.promise;
    }

    function check (content, deferred) {
      for (var key in privacyBlock) {
        var contentSegmentation = content[key];
        var userValues = privacyBlock[key].user_values;


        if (key === 'privacy_departments' && user.role === 'external') {
          privacyBlock[key].passed = true;
          continue;
        }

        if (contentSegmentation && contentSegmentation.length) {
          for (var i = 0; i < contentSegmentation.length; i++) {
            if (userValues.indexOf(contentSegmentation[i]) !== -1) {
              privacyBlock[key].passed = true;
              break;
            }
          }
        } else {
          privacyBlock[key].passed = true;
        }
      }
      var passed = true;

      for (var key in privacyBlock) {
        if (!privacyBlock[key].passed) {
          passed = false;
        }
      }

      if (passed) {
        deferred.resolve(true);
        return;
      }

      deferred.resolve(false);
      return;
    };

    explorer.getUserAccess().$promise
    .then(function(results) {
      for (var key in allToPrivacy) {
        var info = privacyBlock[allToPrivacy[key]];
        info.user_values = results[key] || [];
      }
      check(content, deferred);
    }).catch(function(error) {
      console.log('getUserAccess error: ', error)
    });

    return deferred.promise;
  };

  return {allowView: allowView};
}]);
